__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-prospect-root'].baseUrl;
import ModuleContainer from './components/AxpProspectRoot';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    'reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.5',
      module: require('reactlytics')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.8.1',
      module: require('@americanexpress/one-experiments')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-prospect-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-prospect-root';
}